import DashboardLayout from "@/src/components/layout/DashboardLayout";
import BannerImage from "@/src/components/common/bannerImage";

import { specializationApiService } from "@/src/lib/api-services/specializationApiServices";
import TestCard from "@/src/components/common/testCard";
import BlogList from "@/src/modules/blog/blogList";
import { CustomTextField } from "@/src/lib/ui";
import IconCode from "@/src/lib/iconCode";
import Iconify from "@/src/components/iconify";
import { useState } from "react";

Specialization.getLayout = (page) => <DashboardLayout>{page}</DashboardLayout>;

function Specialization({ data }) {
    const [searchTerm, setSearchTerm] = useState("");

    const filteredProducts = data?.taggedProducts?.filter((item) =>
        item?.configProductCard?.productName
            ?.toLowerCase()
            .includes(searchTerm.toLowerCase())
    );

    return (
        <div>
            <BannerImage
                image={data?.bannerImage}
                title={data?.bannerImageAlt}
            />
            <div className="md:py-12 py-4 max-w-6xl mx-auto">
                <div className="bg-white md:p-5 p-4 rounded-md shadow-md">
                    <h1 className="md:text-xl text-base text-black font-bold leading-3 md:mb-1 mb-2">
                        {data?.specializationName}
                    </h1>

                    <div
                        className="text-gray-800 md:text-sm text-xs"
                        dangerouslySetInnerHTML={{
                            __html: data?.specializationBodyHtml,
                        }}
                    ></div>
                </div>

                <div className="md:mt-5 mt-3">
                    <CustomTextField
                        name="testName"
                        placeholder="Search By Test Name"
                        type="text"
                        className="w-full md:text-base text-sm px-2 "
                        startIcon={<Iconify icon={IconCode.search} />}
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                </div>

                <div className="grid gap-4 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 md:mt-5 mt-3">
                    {filteredProducts?.length > 0 ? (
                        filteredProducts.map((item, index) => (
                            <TestCard key={index} item={item} />
                        ))
                    ) : (
                        <div className="col-span-full text-center text-gray-300 border border-gray-200 rounded-md p-2 bg-gray-100 max-w-96 mx-auto w-full">
                            <span className="capitalize">No test found</span>
                        </div>
                    )}
                </div>
            </div>

            <div className="bg-gray-50 md:py-10 py-5">
                <div className="max-w-6xl mx-auto">
                    <h2 className="md:text-2xl text-xl font-bold text-black mb-3">
                        Related Blogs
                    </h2>

                    <div className="grid gap-6 sm: grid-cols-1 md:grid-cols-2 lg:grid-cols-4">
                        {data?.taggedPages?.length > 0 &&
                            data?.taggedPages.map((item, index) => (
                                <BlogList key={index} item={item} />
                            ))}
                    </div>
                </div>
            </div>
        </div>
    );
}

// This ensures that the page is server-side rendered
export async function getServerSideProps(context) {
    const slug = context.query.slug;
    let data = null;
    // Fetching the specialization data (you can modify this as needed)
    try {
        const response = await specializationApiService.specializationList(
            slug
        );
        data = response?.data;
    } catch (error) {
        console.error(error);
        return {
            notFound: true,
        };
    }

    return {
        props: {
            data: { ...data, routerPath: `specialization/${slug}` }, // Pass the data to the page component as props
        },
    };
}

export default Specialization;
